import React, { useState, useEffect, Suspense } from "react";
import { useDispatch } from "react-redux";
import { io } from "socket.io-client";
import moment from "jalali-moment";

import {
  yesterdayVisitors,
  todayVisitors,
  totalVisitors,
} from "../../store/action";
import Spinner from "../../shared/spinner";

const CoinBank = React.lazy(() => import("./coin-bank"));
const CoinParsian = React.lazy(() => import("./coin-parsian"));

const Main = () => {
  const dispatch = useDispatch();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // console.log("screenWidth", screenWidth > 700);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Add event listener to handle window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [bankCoins, setBankCoins] = useState([]);
  const [parsianCoins, setParsianCoins] = useState([]);

  const [bank, setBank] = useState(true);
  const [parsian, setParsian] = useState(false);

  const [coinUpdatedAt, setCoinUpdatedAt] = useState();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getUpdateAtCoin`)
      .then((response) => {
        if (!response.ok) {
          return new Error(`error ${response.status} occured...`);
        }
        return response.json();
      })
      .then((res) => {
        setCoinUpdatedAt(
          moment(res.updatedAt, "YYYY-MM-DDTHH:mm:ss.SSZ ").format(
            "jYYYY/jM/jD HH:mm z"
          )
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, [setCoinUpdatedAt]);

  useEffect(() => {
    const updateCoins = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_URL}/api/getallcoins`
        );
        const res = await response.json();

        dispatch(yesterdayVisitors(res.yesterdayCountVal));
        dispatch(todayVisitors(res.todayCountVal));
        dispatch(totalVisitors(res.totalCountVal));

        const coins = res?.AllCoins?.slice(0, 8);
        const parsianCoinsData = res?.AllCoins?.slice(8, 23);

        const coin1 = coins.filter((element) => element.id === 1);
        const coin2 = coins.filter((element) => element.id === 5);
        const coin3 = coins.filter(
          (element) => element.id === 2 || element.id === 6
        );
        const coin4 = coins.filter(
          (element) => element.id === 3 || element.id === 7
        );
        const coin5 = coins.filter(
          (element) => element.id === 4 || element.id === 8
        );

        const newBankCoins =
          screenWidth > 700
            ? [...coin1, ...coin2, ...coin3, ...coin4, ...coin5]
            : [...coins];

        setBankCoins(newBankCoins);
        setParsianCoins(parsianCoinsData);
      } catch (err) {
        console.error("Error fetching coins:", err);
      }
    };

    updateCoins();

    const socket = io(process.env.REACT_APP_URL, {
      path: "/api/socket",
      transports: ["polling"],
    });

    socket.on("getCoins", (data) => {
      const coins = data.slice(0, 8);
      const parsianCoinsData = data.slice(8, 23);

      const coin1 = coins.filter((element) => element.id === 1);
      const coin2 = coins.filter((element) => element.id === 5);
      const coin3 = coins.filter(
        (element) => element.id === 2 || element.id === 6
      );
      const coin4 = coins.filter(
        (element) => element.id === 3 || element.id === 7
      );
      const coin5 = coins.filter(
        (element) => element.id === 4 || element.id === 8
      );

      const newBankCoins =
        screenWidth > 700
          ? [...coin1, ...coin2, ...coin3, ...coin4, ...coin5]
          : [...coins];

      setBankCoins(newBankCoins);
      setParsianCoins(parsianCoinsData);
    });

    return () => {
      socket.disconnect();
    };
  }, [dispatch, screenWidth]);

  useEffect(() => {
    return () => {
      document.removeEventListener("dragstart", () => {
        // console.log("event removed..");
      });
    };
  }, []);

  const bankHandler = () => {
    setBank(true);
    setParsian(false);
  };
  const parsianHandler = () => {
    setBank(false);
    setParsian(true);
  };

  const dragHandler = (e) => {
    e.preventDefault();

    document.addEventListener(
      "dragstart",
      function (event) {
        event.dataTransfer.setDragImage(
          event.target,
          window.outerWidth,
          window.outerHeight
        );
      },
      false
    );

    if (setBank) {
      setParsian((prev) => !prev);
      return setBank((prev) => !prev);
    }
    if (setParsian) {
      setBank((prev) => !prev);
      return setParsian((prev) => !prev);
    }
  };

  return (
    <div
      draggable="true"
      className="w-full mx-auto font-IRANSansWeb  caret-transparent -mt-28 relative z-10"
      onDragEndCapture={(event) => dragHandler(event)}
    >
      <div className=" w-[84%] mx-auto flex flex-row-reverse justify-start mt-10 my-4">
        <div className="mx-2 screen500:mx-0">
          <div
            onClick={bankHandler}
            className={`rounded-2xl font-semibold px-4 py-[4px] caret-transparent hover:cursor-pointer 
            screen1800:text-2xl screen1800:px-5
             screen600:text-sm screen400:text-[13px] screen500:px-4 screen500:rounded-lg screen500:py-1 screen340:text-[11px]
              ${
                bank ? "bg-[#f5911e] text-white " : "text-[#f5911e]  bg-white"
              }`}
          >
            سکه های بانکی
          </div>
        </div>
        <div className="mx-2 screen500:mx-1">
          <div
            onClick={parsianHandler}
            className={`rounded-2xl font-semibold px-4 py-[4px] caret-transparent hover:cursor-pointer 
            screen600:text-sm screen400:text-[13px] screen500:px-3 screen500:rounded-lg  screen500:py-1 screen1800:text-2xl screen1800:px-5 screen340:text-[11px]
            ${
              parsian ? "bg-[#f5911e] text-white " : "text-[#f5911e]  bg-white "
            }`}
          >
            سکه های پارسیان
          </div>
        </div>
      </div>

      <Suspense fallback={<Spinner />}>
        {bank && (
          <CoinBank data={bankCoins} coinUpdatedAtDate={coinUpdatedAt} />
        )}
      </Suspense>

      <Suspense fallback={<Spinner />}>
        {parsian && (
          <CoinParsian data={parsianCoins} coinUpdatedAtDate={coinUpdatedAt} />
        )}
      </Suspense>
    </div>
  );
};

export default Main;
